<!-- 协议弹窗 -->
<template>
  <el-dialog v-bind="$attrs" v-on="$listeners">
    <div class="dia-body-sty">
      <!-- right -->
      <div class="r-lab">
        <p :class="activeIndex === 0 ? 'active' : ''">数字证书服务协议</p>
        <p :class="activeIndex === 1 ? 'active' : ''">实名认证服务协议</p>
        <p :class="activeIndex === 2 ? 'active' : ''">用户隐私政策协议</p>
      </div>
      <!-- left -->
      <div class="l-lab">
        <div ref="proRef" class="content-sty">
          <!-- 实名认证服务协议 -->
          <RealName v-show="activeIndex === 2"></RealName>
          <!-- 用户隐私政策协议 -->
          <Privacy v-show="activeIndex === 1"></Privacy>
          <!-- 数字证书服务协议 -->
          <Number v-show="activeIndex === 0"></Number>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button 
        type="primary" 
        :disabled="btnText.indexOf('请阅读至协议末尾') > -1" 
        @click="nextProtocol"
      >{{ btnText }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import Number from '@/components/protocol/pItems/Number.vue'
import Privacy from '@/components/protocol/pItems/Privacy.vue'
import RealName from '@/components/protocol/pItems/RealName.vue'
export default {
  components: {
    Number,
    Privacy,
    RealName,
  },
  data () {
    // 这里存放数据
    return {
      btnText:'请阅读至协议末尾',
      activeIndex:0,
      count:0, // 倒计时初始值
      timer:null // 倒计时定时器
    }
  },
  // 方法集合
  methods: {
    /** 下一份协议 */
    nextProtocol() {
      if(this.activeIndex < 2){
        this.activeIndex += 1;
        this.btnText = '请阅读至协议末尾';
        // 切换协议后，重置滚动条位置
        this.$refs.proRef.scrollTop = 0;
        // 切换协议后，重新检查是否需要禁用按钮（如果新协议内容较短，可能不需要滚动）
        this.checkScrollToBottom();
      } else {
        // 最后一份协议了，点击后可以关闭弹窗了
        this.$emit('close',this.activeIndex);
      }
    },
    /** 检查是否滚动到底部 */
    checkScrollToBottom() {
      const container = this.$refs.proRef;
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      const scrollHeight = container.scrollHeight;
      // 允许 1px 的误差（某些浏览器渲染问题）
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        // 说明当前协议已经滚动到底部了。用户可以进行下一份协议的展示或者其他操作了。
        // 将当前协议key，放入sessionStorage中，表示当前协议已经阅读过了
        const protocol_read = JSON.parse(sessionStorage.getItem('protocol_read') || '[]');
        if(this.count <= 0) {
          this.btnText = '下一份';
          if(this.activeIndex == 2){ this.btnText = '本人已阅读并同意'; }
        }
        if(!protocol_read.includes(this.activeIndex)){
          protocol_read.push(this.activeIndex);
          sessionStorage.setItem('protocol_read', JSON.stringify(protocol_read));
        }
      }
    },
    /** 倒计时 */
    startCountdown() {
      this.count = 3; // 倒计时
      this.btnText = `请阅读至协议末尾 (${this.count}s)`;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.count--;
        if (this.count > 0) {
          this.btnText = `请阅读至协议末尾 (${this.count}s)`;
        } else {
          this.btnText = '请阅读至协议末尾';
          // 初始检查一次，防止内容刚好满一屏（无需滚动即满足底部）
          this.checkScrollToBottom();
          clearInterval(this.timer);
        }
      }, 1000);
    },
  },
  watch: {
    // visible
    '$attrs.visible':{
      handler(val){
        val && this.$nextTick(()=>{
          const container = this.$refs.proRef,read = JSON.parse(sessionStorage.getItem('protocol_read') || '[]');
          container.addEventListener('scroll', this.checkScrollToBottom);
          // 将滚动条重置到顶部，方便下一份协议的阅读
          container.scrollTop = 0;
          this.activeIndex = 0;
          this.btnText = '请阅读至协议末尾';
          // 第一次进入且没有阅读过任何协议，才会开启倒计时
          if(read && read.length == 0){
            this.startCountdown(); // 开始倒计时
          }
        })
      },
      immediate: true,
    }
  },
  destroyed() {
    const container = this.$refs.proRef;
    container && container.removeEventListener('scroll', this.checkScrollToBottom);
    clearInterval(this.timer);
  }
}
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
  .dia-body-sty{
    display: flex;
    .r-lab{
      width: 15%;
      > p{
        font-size: 0.8vw;
        font-weight: bolder;
        color: #333;
        margin: 10px 0;
      }
      .active{
        color: #ec1c1c;
      }
    }
    .l-lab{
      flex: 1;
      .content-sty{
        width: 100%;
        height: 500px;
        overflow-y: scroll;
        padding: 10px 0 10px 10px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// pages/auth/APIAuth/components/protocalNew/index.vue